document.addEventListener("DOMContentLoaded", function() {

  // ─── 1. CINEMATIC LOADER SCREEN ───
  const loader = document.getElementById("brand-loader");
  const progressBar = document.getElementById("loader-progress-bar");
  const percentage = document.getElementById("loader-percentage");

  if (loader && progressBar && percentage) {
    let progress = 0;
    const interval = setInterval(() => {
      progress += 50;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
        setTimeout(() => {
          loader.classList.add("fade-out");
        }, 400);
      }
      progressBar.style.width = progress + "%";
      percentage.textContent = progress + "%";
    }, 40);
  }

  // ─── 2. B2C RETAIL / B2B PARTNER TOGGLE SWITCH ───
  const viewToggle = document.getElementById("view-toggle");
  const b2cLabel = document.querySelector(".b2c-label");
  const b2bLabel = document.querySelector(".b2b-label");

  function toggleTheme(isDark) {
    if (isDark) {
      document.documentElement.setAttribute("data-theme", "dark");
      if (b2cLabel) b2cLabel.classList.remove("active");
      if (b2bLabel) b2bLabel.classList.add("active");
    } else {
      document.documentElement.setAttribute("data-theme", "light");
      if (b2cLabel) b2cLabel.classList.add("active");
      if (b2bLabel) b2bLabel.classList.remove("active");
    }
  }

  if (viewToggle) {
    viewToggle.addEventListener("click", () => {
      const currentTheme = document.documentElement.getAttribute("data-theme");
      toggleTheme(currentTheme !== "dark");
    });
  }

  // ─── 3. QUANTITY SELECTOR ADJUSTER ───
  const qtyInput = document.getElementById("Quantity");
  const btnMinus = document.querySelector(".qty-btn.minus");
  const btnPlus = document.querySelector(".qty-btn.plus");

  if (qtyInput && btnMinus && btnPlus) {
    btnMinus.addEventListener("click", () => {
      let val = parseInt(qtyInput.value) || 1;
      if (val > 1) {
        qtyInput.value = val - 1;
      }
    });

    btnPlus.addEventListener("click", () => {
      let val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // ─── 4. PACKAGE SELECTION & DYNAMIC PRICING ───
  const packageRows = document.querySelectorAll("#package-select .purchase-option-row:not(.purchase-option-redirect)");
  const priceDisplay = document.getElementById("pdp-active-price");
  const priceLabel = document.getElementById("pdp-price-label");

  packageRows.forEach(row => {
    row.addEventListener("click", () => {
      packageRows.forEach(r => r.classList.remove("selected"));
      row.classList.add("selected");

      const pkg = row.dataset.package;
      if (pkg === "tablets-600" && priceDisplay && priceLabel) {
        priceDisplay.textContent = "RM 498.00";
        priceLabel.textContent = "/ 600 chewable tablets";
      } else if (pkg === "vials" && priceDisplay && priceLabel) {
        priceDisplay.textContent = "RM 2,499.00";
        priceLabel.textContent = "/ 10 vials × 12ml";
      }
    });
  });

  // ─── 5. SPECIFICATION ACCORDION CLICKS ───
  const accordionTriggers = document.querySelectorAll(".spec-acc-trigger");
  
  accordionTriggers.forEach(trigger => {
    trigger.addEventListener("click", () => {
      const item = trigger.closest(".pdp-spec-accordion-item");
      if (item) {
        item.classList.toggle("open");
      }
    });
  });

  // ─── 6. IMAGE GALLERY THUMBNAIL SWITCHER ───
  const thumbs = document.querySelectorAll(".lth9-thumb");
  const mainImg = document.querySelector(".lth9-gallery-main-img");

  thumbs.forEach(thumb => {
    thumb.addEventListener("click", () => {
      thumbs.forEach(t => t.classList.remove("active"));
      thumb.classList.add("active");
      
      const img = thumb.querySelector("img");
      if (img && mainImg) {
        mainImg.style.opacity = "0.2";
        mainImg.style.transform = "scale(0.95)";
        setTimeout(() => {
          mainImg.src = img.src;
          mainImg.style.opacity = "1";
          mainImg.style.transform = "scale(1)";
        }, 150);
      }
    });
  });

  // ─── 7. CLINICAL TELEMETRY TABS SWITCHER ───
  const clinicalTabBtns = document.querySelectorAll(".clinical-tab-btn");
  const clinicalPanels = document.querySelectorAll(".clinical-panel");

  clinicalTabBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      if (btn.classList.contains("active")) return;

      clinicalTabBtns.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      const targetId = btn.dataset.panel;
      clinicalPanels.forEach(panel => {
        if (panel.id === targetId) {
          panel.style.display = "block";
          panel.classList.add("active");
        } else {
          panel.style.display = "none";
          panel.classList.remove("active");
        }
      });
    });
  });

  // ─── 8. 5 HEALTH PILLARS TAB SYSTEM ───
  const pillarsData = {
    cancer: {
      title: "Cellular Restoration 🧬",
      desc: "Concentrated microalgae extract stimulates active lymphocyte sweep. Bypasses standard digestive processes to penetrate cell walls, restoring base-level biological frameworks under oxidative stress.",
      stat1Val: "94.2%",
      stat1Lbl: "Cell Recovery Index",
      stat2Val: "4.8x",
      stat2Lbl: "Immune Sweep Factor"
    },
    heart: {
      title: "Cardiovascular Sweep 🫀",
      desc: "Nitric oxide pathway stimulation restores arterial elasticity. Resveratrol dual PPAR agonists actively mobilize fatty deposits, enhancing total blood flow clearance and promoting vascular health.",
      stat1Val: "88.6%",
      stat1Lbl: "Vascular Pathway Clearance",
      stat2Val: "-18%",
      stat2Lbl: "Fasting LDL Reduction"
    },
    diabetes: {
      title: "Glucose Modulation 🩸",
      desc: "Calibrates glucose receptors on cell borders. Accelerates insulin binding responses to stabilize HbA1c and fasting blood sugar indices without dangerous plasma spikes.",
      stat1Val: "5.4 mmol/L",
      stat1Lbl: "Fasting Glucose Target",
      stat2Val: "92.8%",
      stat2Lbl: "Insulin Receptor Response"
    },
    antiaging: {
      title: "DNA Double-Helix Repair 👩‍⚕️",
      desc: "SIRT-1 longevity gene upregulation defends double-helix DNA structures from free-radical decay, repairing cellular transcription paths and protecting chromosomal data.",
      stat1Val: "3.2x",
      stat1Lbl: "SIRT-1 Activity Level",
      stat2Val: "14 Years",
      stat2Lbl: "Biological Age Reduction"
    },
    longevity: {
      title: "Telomere Cap Defense ♾️",
      desc: "Boosts active telomerase enzyme output. Extends chronological chromosome protective caps to prolong cellular division capacity and safeguard cell replication lifecycle.",
      stat1Val: "74.8%",
      stat1Lbl: "Telomere Defense Ratio",
      stat2Val: "+15.6%",
      stat2Lbl: "Extended Cell Lifespan"
    }
  };

  const tabButtons = document.querySelectorAll(".lth9-pillar-tab-btn");
  const pTitle = document.getElementById("lth9-pillar-title");
  const pDesc = document.getElementById("lth9-pillar-desc");
  const pStat1Num = document.getElementById("lth9-pillar-stat1-num");
  const pStat1Label = document.getElementById("lth9-pillar-stat1-label");
  const pStat2Num = document.getElementById("lth9-pillar-stat2-num");
  const pStat2Label = document.getElementById("lth9-pillar-stat2-label");
  const displayCard = document.querySelector(".lth9-pillar-display-card");

  tabButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      if (btn.classList.contains("active")) return;

      tabButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");

      const key = btn.dataset.pillar;
      const data = pillarsData[key];
      if (!data) return;

      if (displayCard) {
        displayCard.style.opacity = "0.2";
        displayCard.style.transform = "translateY(10px)";
      }
      
      setTimeout(() => {
        if (pTitle) pTitle.textContent = data.title;
        if (pDesc) pDesc.textContent = data.desc;
        if (pStat1Num) pStat1Num.textContent = data.stat1Val;
        if (pStat1Label) pStat1Label.textContent = data.stat1Lbl;
        if (pStat2Num) pStat2Num.textContent = data.stat2Val;
        if (pStat2Label) pStat2Label.textContent = data.stat2Lbl;

        if (displayCard) {
          displayCard.style.opacity = "1";
          displayCard.style.transform = "translateY(0)";
        }
      }, 250);
    });
  });

  // ─── 9. HUD SCROLL SPY TRACKER ───
  const hudHeader = document.getElementById("lth9-hud-header");
  const hudTagDisplay = document.getElementById("lth9-hud-tag-display");
  const sections = document.querySelectorAll("[data-hud-sec]");
  const mainSection = document.querySelector(".lth9-product-detail-block");

  const tagMap = {
    hero: "TELEMETRY SCANNING",
    comparison: "BENCHMARK COMPARISON",
    science: "ABSORPTION SCIENCE",
    research: "CLINICAL REGISTRY",
    pillars: "CELLULAR RESTORATION",
    evidence: "PATIENT BIO-ASSAYS",
    advisor: "CALIBRATION REPORT"
  };

  const observerOptions = {
    root: null,
    rootMargin: "-25% 0px -55% 0px",
    threshold: 0.1
  };

  let activeSectionKey = "";

  const hudObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const secName = entry.target.dataset.hudSec;
        if (secName && tagMap[secName] && activeSectionKey !== secName) {
          activeSectionKey = secName;
          
          if (hudTagDisplay) {
            hudTagDisplay.style.opacity = "0";
            hudTagDisplay.style.transform = "translateY(4px)";
            
            setTimeout(() => {
              hudTagDisplay.textContent = tagMap[secName];
              hudTagDisplay.style.opacity = "1";
              hudTagDisplay.style.transform = "translateY(0)";
            }, 150);
          }
        }
      }
    });
  }, observerOptions);

  sections.forEach(sec => hudObserver.observe(sec));

  window.addEventListener("scroll", () => {
    if (!mainSection || !hudHeader) return;
    const rect = mainSection.getBoundingClientRect();
    if (rect.top <= -100) {
      hudHeader.classList.add("hud-active");
    } else {
      hudHeader.classList.remove("hud-active");
    }
  }, { passive: true });

  // ─── 10. 3D DECK CAROUSEL SYSTEM (TESTIMONIALS) ───
  const cards = document.querySelectorAll(".lth9-card-3d");
  const prevBtn = document.querySelector(".lth9-ev-nav-prev");
  const nextBtn = document.querySelector(".lth9-ev-nav-next");
  
  if (cards.length > 0) {
    let activeIdx = 0;

    function updateCarousel() {
      cards.forEach((card, idx) => {
        card.className = "lth9-card-3d";
        card.classList.remove("flipped");

        if (idx === activeIdx) {
          card.classList.add("active-card");
        } else if (idx === (activeIdx - 1 + cards.length) % cards.length) {
          card.classList.add("left-card");
        } else if (idx === (activeIdx + 1) % cards.length) {
          card.classList.add("right-card");
        }
      });
    }

    cards.forEach(card => {
      card.addEventListener("click", (e) => {
        if (card.classList.contains("active-card")) {
          if (!e.target.classList.contains("flip-back-btn")) {
            card.classList.toggle("flipped");
          }
        } else if (card.classList.contains("left-card")) {
          activeIdx = (activeIdx - 1 + cards.length) % cards.length;
          updateCarousel();
        } else if (card.classList.contains("right-card")) {
          activeIdx = (activeIdx + 1) % cards.length;
          updateCarousel();
        }
      });
    });

    const flipBackBtns = document.querySelectorAll(".flip-back-btn");
    flipBackBtns.forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const card = btn.closest(".lth9-card-3d");
        if (card) {
          card.classList.remove("flipped");
        }
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        activeIdx = (activeIdx - 1 + cards.length) % cards.length;
        updateCarousel();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        activeIdx = (activeIdx + 1) % cards.length;
        updateCarousel();
      });
    }

    updateCarousel();
  }

  // ─── 11. BIOMARKER ADVISOR DOSAGE SYSTEM ───
  const advisorForm = document.getElementById("lth9-advisor-form");
  const resultPanel = document.getElementById("lth9-result-panel");
  const resTitle = document.getElementById("lth9-result-title");
  const resDose = document.getElementById("lth9-result-dose");
  const resDesc = document.getElementById("lth9-result-desc");

  if (advisorForm) {
    advisorForm.addEventListener("submit", (e) => {
      e.preventDefault();

      const goal = document.getElementById("diag_goal").value;
      const sugar = document.getElementById("diag_sugar").value;
      const age = document.getElementById("diag_age").value;

      let title = "SIRT-1 Loading Phase Recommended";
      let dose = "1 Vial (12ml) Daily";
      let desc = "Your biomarkers indicate normal metabolic activity. A daily baseline dose is recommended before meals. Hold under the tongue for 30 seconds before swallowing for sublingual absorption.";

      if (sugar === "high") {
        title = "Intensive Regeneration Protocol";
        dose = "3 Vials Daily (Intensive Loading)";
        desc = "Your fasting sugar indicators reflect elevated glycemic stress. Consuming 1 vial before breakfast, lunch, and dinner activates cellular receptors. Take directly upon opening.";
      } else if (sugar === "pre" || age === "tier3" || goal === "sirt1") {
        title = "Metabolic Repair Protocol";
        dose = "2 Vials Daily (Restoration loading)";
        desc = "Biomarkers reflect pre-restoration activity or advanced age tier. Take 1 vial before breakfast and 1 vial before dinner. Upregulates PGC-1a and calms chronic inflammation vectors.";
      }

      if (resultPanel) {
        resultPanel.style.display = "none";
        setTimeout(() => {
          if (resTitle) resTitle.textContent = title;
          if (resDose) resDose.textContent = dose;
          if (resDesc) resDesc.textContent = desc;
          resultPanel.style.display = "block";
          resultPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 100);
      }
    });
  }

  // ─── 12. CHECKOUT MODAL & QR CODE SYSTEM ───
  const buyBtn = document.getElementById("pdp-buy-btn");
  const buyNowBtn = document.querySelector(".lth9-buy-now-btn");
  const modalOverlay = document.getElementById("checkout-modal");
  const modalCloseBtn = document.getElementById("modal-close-btn");
  const checkoutTabButtons = document.querySelectorAll(".lth9-modal-tab-btn");
  const checkoutPanels = document.querySelectorAll(".lth9-modal-panel");
  const receiptInput = document.getElementById("receipt-file");
  const dropZone = document.getElementById("receipt-drop-zone");
  const uploadStatus = document.getElementById("upload-status-text");
  const whatsappBtn = document.getElementById("whatsapp-verify-btn");

  // Show Modal
  function showModal(e) {
    if (e) e.preventDefault();
    if (modalOverlay) {
      modalOverlay.style.display = "flex";
      document.body.style.overflow = "hidden";
    }
  }

  // Hide Modal
  function hideModal() {
    if (modalOverlay) {
      modalOverlay.style.display = "none";
      document.body.style.overflow = "";
    }
  }

  function handleBuyClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
    const isShopify = window.Shopify || (!window.location.hostname.includes("localhost") && !window.location.hostname.includes("127.0.0.1"));
    if (isShopify) {
      checkoutViaShopifyCart();
    } else {
      showModal();
    }
  }

  if (buyBtn) buyBtn.addEventListener("click", handleBuyClick);
  if (buyNowBtn) buyNowBtn.addEventListener("click", handleBuyClick);
  if (modalCloseBtn) modalCloseBtn.addEventListener("click", hideModal);

  if (modalOverlay) {
    modalOverlay.addEventListener("click", (e) => {
      if (e.target === modalOverlay) hideModal();
    });
  }

  checkoutTabButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      checkoutTabButtons.forEach(b => b.classList.remove("active"));
      checkoutPanels.forEach(p => p.style.display = "none");

      btn.classList.add("active");
      const targetPanel = document.getElementById(btn.dataset.tab);
      if (targetPanel) {
        targetPanel.style.display = "block";
      }
    });
  });

  // ─── DUITNOW QR MODAL DIRECT TRIGGERS ───
  function openQrModal(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    showModal();
    checkoutTabButtons.forEach(b => b.classList.remove("active"));
    checkoutPanels.forEach(p => p.style.display = "none");
    const qrTab = document.querySelector('.lth9-modal-tab-btn[data-tab="qr-panel"]');
    const qrPanel = document.getElementById("qr-panel");
    if (qrTab) qrTab.classList.add("active");
    if (qrPanel) qrPanel.style.display = "block";
  }

  const qrTriggerBtn = document.getElementById("pdp-qr-trigger-btn");
  const directQrBtn = document.getElementById("pdp-direct-qr-submit-btn");

  if (qrTriggerBtn) qrTriggerBtn.addEventListener("click", openQrModal);
  if (directQrBtn) directQrBtn.addEventListener("click", openQrModal);

  // Receipt uploader logic
  if (receiptInput && dropZone && uploadStatus && whatsappBtn) {
    receiptInput.addEventListener("change", handleFileSelection);

    dropZone.addEventListener("dragover", (e) => {
      e.preventDefault();
      dropZone.classList.add("dragover");
    });

    dropZone.addEventListener("dragleave", () => {
      dropZone.classList.remove("dragover");
    });

    dropZone.addEventListener("drop", (e) => {
      e.preventDefault();
      dropZone.classList.remove("dragover");
      if (e.dataTransfer.files.length > 0) {
        receiptInput.files = e.dataTransfer.files;
        handleFileSelection();
      }
    });

    function handleFileSelection() {
      const file = receiptInput.files[0];
      if (file) {
        uploadStatus.textContent = `Loaded: ${file.name} (${(file.size / 1024).toFixed(1)} KB)`;
        dropZone.style.borderColor = "#25D366";
        dropZone.style.background = "rgba(37, 211, 102, 0.04)";
        
        whatsappBtn.textContent = "WhatsApp Verify Payment Now";
        whatsappBtn.classList.add("active");
        
        const message = `Hi LT International, I have purchased the LT Extracts Liquid Box and completed the payment of RM2,499.00 via DuitNow QR. Attached is my payment receipt (${file.name}).`;
        whatsappBtn.href = `https://wa.me/60198686080?text=${encodeURIComponent(message)}`;
      }
    }
  }

  // ─── 13. PRODUCT UPSELL INTERACTION & SUMMATION ───
  const upsellCheckbox = document.getElementById("upsell-chewables-checkbox");
  const modalProductSummary = document.getElementById("modal-product-summary");
  const modalUpsellBanner = document.getElementById("modal-upsell-banner");
  const modalUpsellAddBtn = document.getElementById("modal-upsell-add-btn");
  const stripeCheckoutBtn = document.getElementById("stripe-checkout-btn");
  const quantityInput = document.getElementById("Quantity");

  function getOrderTotal() {
    const qty = quantityInput ? (parseInt(quantityInput.value) || 1) : 1;
    let total = qty * 2499;
    if (upsellCheckbox && upsellCheckbox.checked) {
      total += 498;
    }
    return total;
  }

  function updateOrderSummaries() {
    const qty = quantityInput ? (parseInt(quantityInput.value) || 1) : 1;
    const total = getOrderTotal();
    const hasUpsell = upsellCheckbox && upsellCheckbox.checked;

    const formattedTotal = total.toLocaleString("en-US", { minimumFractionDigits: 2 });
    const formattedPriceStr = `RM ${formattedTotal}`;
    
    // Update Modal Summary Text
    if (modalProductSummary) {
      if (hasUpsell) {
        modalProductSummary.textContent = `LT Extracts Liquid Box (${qty}x) + Chewable Tablets Flagship (1x)`;
      } else {
        modalProductSummary.textContent = `LT Extracts Liquid Box (${qty}x)`;
      }
    }

    // Hide or show modal banner
    if (modalUpsellBanner) {
      modalUpsellBanner.style.display = hasUpsell ? "none" : "flex";
    }

    // Update Stripe CTA with current order total
    if (stripeCheckoutBtn) {
      stripeCheckoutBtn.textContent = `Proceed to Secure Checkout (${formattedPriceStr})`;
      stripeCheckoutBtn.href = hasUpsell
        ? "https://checkout.stripe.com/pay/liquid_with_tablets"
        : "https://checkout.stripe.com/pay/liquid_onetime";
    }

    // ─── DYNAMIC DUITNOW QR AMOUNT SYNC ───
    // Update all dynamic DuitNow QR price labels on page and in modal
    const qrAmountEls = document.querySelectorAll(".qr-dynamic-amount-val");
    qrAmountEls.forEach(el => {
      el.textContent = formattedPriceStr;
    });

    // Update WhatsApp pre-filled message with exact total amount and items list
    const whatsappBtn = document.getElementById("whatsapp-verify-btn");
    const receiptInput = document.getElementById("receipt-file");
    if (whatsappBtn) {
      const file = (receiptInput && receiptInput.files[0]) ? receiptInput.files[0] : null;
      const fileName = file ? file.name : "payment_receipt.jpg";
      const itemsList = hasUpsell 
        ? `LT Extracts Liquid Box (${qty}x) + LT Chewable Tablets (1x)`
        : `LT Extracts Liquid Box (${qty}x)`;
      const message = `Hi LT International, I have purchased ${itemsList} and completed the payment of ${formattedPriceStr} via DuitNow QR. Attached is my payment receipt (${fileName}).`;
      whatsappBtn.href = `https://wa.me/60198686080?text=${encodeURIComponent(message)}`;
    }
  }

  if (upsellCheckbox) {
    upsellCheckbox.addEventListener("change", updateOrderSummaries);
  }

  const plusBtn = document.querySelector(".qty-btn.plus");
  const minusBtn = document.querySelector(".qty-btn.minus");
  if (plusBtn) plusBtn.addEventListener("click", updateOrderSummaries);
  if (minusBtn) minusBtn.addEventListener("click", updateOrderSummaries);

  if (modalUpsellAddBtn && upsellCheckbox) {
    modalUpsellAddBtn.addEventListener("click", () => {
      upsellCheckbox.checked = true;
      updateOrderSummaries();
    });
  }

  const openModalElements = [document.getElementById("pdp-buy-btn"), document.querySelector(".lth9-buy-now-btn")];
  openModalElements.forEach(el => {
    if (el) {
      el.addEventListener("click", updateOrderSummaries);
    }
  });

  // ─── 14. LIVE SHOPIFY CART INTEGRATION ───
  const LIQUID_VARIANT_ID = '49257376252137';
  const TABLETS_VARIANT_ID = '49257425371369';

  function checkoutViaShopifyCart() {
    const qtyInput = document.getElementById("Quantity");
    const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
    const upsellCheckbox = document.getElementById("upsell-chewables-checkbox");
    const hasUpsell = upsellCheckbox ? upsellCheckbox.checked : false;

    let itemsToCart = [
      { id: LIQUID_VARIANT_ID, quantity: qty }
    ];
    if (hasUpsell) {
      itemsToCart.push({ id: TABLETS_VARIANT_ID, quantity: 1 });
    }

    const buyBtn = document.getElementById("pdp-buy-btn");
    const buyNowBtn = document.querySelector(".lth9-buy-now-btn");
    const originalText1 = buyBtn ? buyBtn.textContent : 'ORDER NOW →';
    const originalText2 = buyNowBtn ? buyNowBtn.textContent : 'ORDER NOW →';

    if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = "Processing Checkout..."; }
    if (buyNowBtn) { buyNowBtn.disabled = true; buyNowBtn.textContent = "Processing..."; }

    fetch('/cart/clear.js', { method: 'POST' })
      .then(() => {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToCart })
        });
      })
      .then(async (response) => {
        if (!response.ok) {
          const errJson = await response.json().catch(() => ({}));
          const errMsg = errJson.description || errJson.message || 'Item is out of stock in Shopify inventory';
          throw new Error(errMsg);
        }
        return response.json();
      })
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(err => {
        console.error('Shopify Cart API Error:', err);
        alert("Shopify Checkout Notice: " + err.message + "\n\n(Tip: In Shopify Admin -> Products -> 3S Epi Liquid, set inventory to available or check 'Continue selling when out of stock').");
        if (buyBtn) { buyBtn.disabled = false; buyBtn.textContent = originalText1; }
        if (buyNowBtn) { buyNowBtn.disabled = false; buyNowBtn.textContent = originalText2; }
      });
  }

  // ─── 15. SCROLL REVEAL ───
  (function() {
    const revealEls = document.querySelectorAll('.reveal-up');
    if (!revealEls.length) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => observer.observe(el));
  })();

  // ─── 16. BIO RESTORE TAB SWITCHER ───
  (function() {
    const bioTabs = document.querySelectorAll('.bio-tab');
    const bioPanels = document.querySelectorAll('.bio-panel');
    if (!bioTabs.length) return;
    bioTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.bio;
        bioTabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        bioPanels.forEach(p => {
          p.style.display = p.id === 'bio-' + target ? 'block' : 'none';
        });
      });
    });
  })();

  // ─── 17. AUTOMATICALLY FORMAT SHOPIFY TOP HEADER LOGO TEXT ───
  const logoElements = document.querySelectorAll(".header__heading-link, .header__heading, .site-header__logo-link, header a[href='/']");
  logoElements.forEach(el => {
    if (el && el.textContent.includes("LT International") && !el.querySelector("em")) {
      el.innerHTML = 'LT <em style="font-family:\'Cormorant Garamond\', serif !important; font-style:italic !important; font-weight:400 !important; color:#D4AF37 !important;">International</em>';
    }
  });

  // ─── 18. SHAREABLE VIDEO & AUTO-PLAY DEEP LINK SYSTEM ───
  const videoElement = document.getElementById("science-video-element");
  const videoContainer = document.getElementById("science-video-container");
  const shareVideoBtn = document.getElementById("share-video-link-btn");
  const shareToastMsg = document.getElementById("share-toast-msg");

  // Check URL parameters or Hash tag for direct video link (e.g. ?play_video=1 or #science)
  const urlParams = new URLSearchParams(window.location.search);
  const shouldPlayVideo = urlParams.get("play_video") === "1" || window.location.hash === "#science" || window.location.hash === "#video";

  if (shouldPlayVideo && videoContainer && videoElement) {
    setTimeout(() => {
      videoContainer.scrollIntoView({ behavior: "smooth", block: "center" });
      videoElement.muted = false; // unmute video for visitor
      videoElement.play().catch(() => {
        videoElement.muted = true; // fallback to muted autoplay if browser blocks audio
        videoElement.play();
      });
      videoContainer.style.outline = "2px solid #D4AF37";
      setTimeout(() => { videoContainer.style.outline = "none"; }, 3000);
    }, 600);
  }

  // Copy shareable video URL to clipboard when button clicked
  if (shareVideoBtn) {
    shareVideoBtn.addEventListener("click", () => {
      const shareUrl = window.location.origin + window.location.pathname + "?play_video=1#science";
      navigator.clipboard.writeText(shareUrl).then(() => {
        if (shareToastMsg) {
          shareToastMsg.style.display = "inline-block";
          setTimeout(() => { shareToastMsg.style.display = "none"; }, 2500);
        }
      }).catch(() => {
        prompt("Copy this shareable video link:", shareUrl);
      });
    });
  }

});
